// @flow

import React from "react";
import { useSelector } from "react-redux";
import { Portal } from "@chakra-ui/react";

import { getCurrentLanguage, getIsHomescreenLoading } from "src/reducers";

import Header from "./Header";
import Loader from "./Loader";
import HomescreenGrid from "./HomescreenGrid";

import { Homescreen as StyledHomescreen, SectionContainer } from "./styles";
import { Overlay } from "src/styles/splitPane";

const Homescreen = () => {
  const language = useSelector(({ app }) => getCurrentLanguage(app));
  const loading = useSelector(({ app }) => getIsHomescreenLoading(app));

  return (
    <Portal>
      <Overlay>
        <StyledHomescreen key={language}>
          <SectionContainer>
            <Header />
            {loading !== false ? <Loader /> : <HomescreenGrid />}
          </SectionContainer>
        </StyledHomescreen>
      </Overlay>
    </Portal>
  );
};

export default Homescreen;
